// extracted by mini-css-extract-plugin
export default {"fingerprintImage":"FingerprintLoading_fingerprintImage__j5VUB","blinkBorder":"FingerprintLoading_blinkBorder__0NUT0"};